angular.module('dealerware.web.components')

    .value('dealerwareGoogleTagManagerController', function ($scope, $rootScope) {

        var analyticsListener = $rootScope.$on('triggerGoogleAnalyticsTrackingEvent', function (e, args) {

            if (! window.dataLayer) {
                return;
            }

            var gtmObj = { };
            if (args.type === 'event') {
                gtmObj.id = args.id || '<blank-id>';
                gtmObj.category = args.category || '<blank-category>';
                gtmObj.label = args.label || '<blank-label>';
                window.dataLayer.push(gtmObj);
            }
            else if (args.type === 'ecommerce') {
                angular.extend(gtmObj, args.product, args.action);
                window.dataLayer.push(gtmObj);
            }
            else if (args.type === 'page') {

                window.dataLayer.push({
                    event       : 'VirtualPageview',
                    attributes  : {
                        route: args.route
                    }
                });
            }
        });

        $scope.$on('$destroy', function () {GoogleTagManagerContainerId
            analyticsListener();
        });
    })

    .directive('dealerwareGoogleTagManager', function (
        GoogleTagManagerContainerId, dealerwareGoogleTagManagerController
    ) {

        var template = '( function (w, d, s, l, i) {'
            + '      w[l] = w[l] || [ ];'
            + '      w[l].push({'
            + '          \'gtm.start\' : new Date().getTime(),'
            + '          event         : \'gtm.js\''
            + '      });'
            + '      var f = d.getElementsByTagName(s)[0],'
            + '          j = d.createElement(s),'
            + '          dl = l != \'dataLayer\' ? \'&l=\' + l : \'\';'
            + '          j.async = true;'
            + '          j.src = \'https://www.googletagmanager.com/gtm.js?id=\' + i + dl;'
            + '      f.parentNode.insertBefore(j,f);'
            + '  }'
            + ') ( window, document, \'script\', \'dataLayer\', \''
            + GoogleTagManagerContainerId + '\');';

        return {
            restrict    : 'E',
            replace     : true,
            scope       : { },

            controller  : dealerwareGoogleTagManagerController,

            link: function (scope, $element) {

                if (GoogleTagManagerContainerId !== undefined) {
                    $element.replaceWith(angular.element('<script>' + template + '</script>'));
                }
            }
        };
    })

    .directive('dealerwareGoogleTagManagerNoScript', function (
        GoogleTagManagerContainerId, dealerwareGoogleTagManagerController
    ) {
        var template =
            '<iframe src="//www.googletagmanager.com/ns.html?id=' + GoogleTagManagerContainerId
            + '" height="0" width="0" style="display: none; visibility: hidden">'
            + '</iframe>';

        return {
            restrict    : 'E',
            replace     : true,
            scope       : { },

            link: function (scope, $element) {

                if (GoogleTagManagerContainerId !== undefined) {
                    $element.replaceWith(angular.element('<noscript>' + template + '</noscript>'));
                }
            }
        };
    });
